// src/components/UploadForm.js

import React, {useRef} from 'react';
import {CustomButton} from '../Button/buttonComponents.component';
function UploadForm({onUpload, loading}) {
  const fileInputRef = useRef(null);

  const handleFileChange = async (event) => {
    const files = event.target.files;
    if (files.length === 0) return;

    const file = files[0];
    if (file.type !== 'application/pdf') {
      alert('Please upload a valid PDF file.');
      return;
    }

    const formData = new FormData();
    formData.append('file', file);
    // console.log('FORMDATA::', formData);
    await onUpload(formData);
  };

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  return (
    <div>
      <input type="file" accept="application/pdf" ref={fileInputRef} style={{display: 'none'}} onChange={handleFileChange} />

      <CustomButton className={loading ? 'element-disabled' : ''} onClick={handleButtonClick} disabled={loading}>
        {loading ? 'Uploading...' : `Upload PDF`}
      </CustomButton>
    </div>
  );
}

export default UploadForm;
